import classNames from 'classnames'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Icon } from '@campgladiator/cgui-core.atoms.icon'
import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import {
  analytics,
  analyticsEvent,
  analyticsEventLabel,
} from '../../../../common/utility/analytics'
import { twentyFourHourTimeStringToDate } from '../../../../common/utility/time'
import { OutdoorLocationsProps } from '../../TrainerBio.d'
import { OverflowContainer } from '../OverflowContainer'
import styles from './OutdoorLocations.module.scss'

const printTime = (time: string) =>
  twentyFourHourTimeStringToDate(time).toLocaleTimeString([], {
    hour: 'numeric',
    minute: 'numeric',
  })

const { trackCustomEvent } = analytics
const { LIST_ITEM, PAGINATE } = analyticsEvent
const {
  TRAINER_BIO: { OUTDOOR_LOCATION_CARD, OUTDOOR_LOCATIONS },
} = analyticsEventLabel

const OutdoorLocations = ({
  className = '',
  isDesktop,
  locations,
  ...props
}: OutdoorLocationsProps) => {
  const hasLocations = !!locations.length

  return hasLocations ? (
    <section className={classNames(styles.wrapper, className)} {...props}>
      <OverflowContainer
        className={styles.locations}
        heading="Outdoor Locations"
        scrollOnClick={() => trackCustomEvent(PAGINATE(OUTDOOR_LOCATIONS))}
      >
        {locations.map((location) => (
          <Card
            flat
            key={location.id}
            className={styles.card}
            onClick={() => trackCustomEvent(LIST_ITEM(OUTDOOR_LOCATION_CARD))}
          >
            <Paragraph
              className={styles.name}
              size={isDesktop ? 'small' : 'xsmall'}
              weight="book"
            >
              {location.location.name}
            </Paragraph>
            <div className={styles.bottom}>
              <div className={styles.date}>
                <Paragraph className={styles.days} size="small" weight="book">
                  {location.days}
                </Paragraph>
                <Paragraph size={isDesktop ? 'large' : 'default'} weight="bold">
                  {printTime(location.time)}
                </Paragraph>
              </div>
              <Icon className={styles.marker} name="icon-map-marker-solid" />
            </div>
          </Card>
        ))}
      </OverflowContainer>
    </section>
  ) : null
}

export default OutdoorLocations
